<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="500px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      Set engine serial number(s)
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text>
      <div
        v-for="(engineSerialNumberObject, index) in engineSerialNumbersDirty"
        :key="index"
      >
        <v-text-field
          v-model="engineSerialNumberObject.serial_number"
          data-vv-as="serial number"
          :error-messages="veeErrors.collect('engine_serial_number' + '-' + index)"
          :name="'engine_serial_number' + '-' + index"
          :label="`Serial number for ${engineSerialNumberObject.model} (${engineSerialNumberObject.power} HP)`"
          outlined
        />
      </div>
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
  import Yacht from '@/models/Yacht'
  import ContentDialog from '@/components/helpers/Dialog'

  export default {
    name: 'YachtEngineSerialNumbersEditDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        engineSerialNumbersDirty: [],
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    watch: {
      yacht() {
        this.prepareData()
      }
    },
    created() {
      this.prepareData()
    },
    methods: {
      prepareData() {
        let modelEngines = this.yacht.model.engines
        let serialNumbers = this.yacht.engine_serial_numbers

        this.engineSerialNumbersDirty = modelEngines.map((e, i) => {
          let serialNumberObject = serialNumbers ? serialNumbers[i] : undefined

          return {
            ...e,
            serial_number: serialNumberObject ? serialNumberObject.serial_number : null
          }
        })
      },
      async submit() {
        let validation = await this.$validator.validate()

        if (!validation) return

        this.save()
      },
      async save() {
        this.submitting = true

        let formData = {
          engine_serial_numbers: this.engineSerialNumbersDirty.map(e => {
            return {
              yacht_engine_id: e.id,
              serial_number: e.serial_number
            }
          })
        }

        try {
          let response = await Yacht.api.updateYachtEngineSerialNumbers(this.yacht.id, formData)
          this.$emit('update:yacht', response)
          this.modalVisible = false
          this.$store.dispatch('alert', {
            'text': 'Updated yacht engine serial numbers',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
